export var PatientStatus;
(function (PatientStatus) {
    PatientStatus["Pending"] = "Pending";
    PatientStatus["Activated"] = "Activated";
})(PatientStatus || (PatientStatus = {}));
